import React from "react";
import withRouter from "../../withRouter";
import { getActiveLoginUsersList, getAdminDetails, getAdminList } from "../../action/admin/getActiveLoginUserList";
import { getAdminEmailInStorage } from "../../utils/helpers/storageUtils";
import Loader from "../loader/loader";
import CreateAdminModal from "./modals/createAdminModal";
import SuccessModal from "./modals/successModal";
import DeleteAdminModal from "./modals/deleteAdminModal";
import PropTypes from "prop-types";
import { frontEndLogs } from "../../action/logs/frontEndLogs";
import { manualLogout } from "../../action/auth/logout";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
const USERS_PER_PAGE = Number(process.env.ADMIN_USER_LIST_PAGE_SIZE) || 20;
export class AdminDashboard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searchValue: "",
			showDropdown: false,
			currentPage: 1,
			users: [],
			admins: [],
			activeTab: "users",
			loading: true,
			showCreateModal: false,
			showResponseModal: false,
			responseMessage: "",
			isSuccess: false,
			showDeleteModal: false,
			selectedAdmin: null,
            responseTitle: ""
		}
		this.dropdownRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleOutsideClick);
		this.initializeAdminDashboard();
	}

	initializeAdminDashboard = async () => {
		analyticsClickEvent('admin_dashboard_opened', '');
		frontEndLogs('admin_dashboard_opened', false, 200, 'admin_dashboard');
		try {
			const hasSession = localStorage.getItem("sessionId") &&
				localStorage.getItem("userRole") === "admin" &&
				!sessionStorage.getItem("UserName");

			if (hasSession) {
				await this.setAdminDetailsInSession();
			}
			await this.getActiveLoginUsers();
			await this.getAdminListDetails();
		} catch (err) {
			console.error("Failed to initialize admin dashboard:", err);
			frontEndLogs('admin_dashboard_initialization_failed', true, 500, err?.message || 'Unknown error'
			);
		} finally {
			this.setState({ loading: false })
		}
	}

	componentWillUnmount() { document.removeEventListener("mousedown", this.handleOutsideClick) }

	getActiveLoginUsers = async () => {
		try {
			const response = await getActiveLoginUsersList({search:""});
			if (response?.statusCode === 200) {
				this.setState({ users: response.data || [] })
			} else {
				this.setState({ users: [] })
			}
		}
		catch (err) {
			console.error("Failed to fetch active users:", err);
			this.setState({ users: [] })
		}
	}

	getAdminListDetails = async () => {
		try {
			const response = await getAdminList({search:""});
			if (response?.statusCode === 200) {
				this.setState({ admins: response.data || [] })
			} else {
				this.setState({ admins: [] })
			}
		}
		catch (err) {
			console.error("Failed to fetch admin list:", err);
			this.setState({ admins: [] })
		}
	}

	setAdminDetailsInSession = async () => {
		const email = getAdminEmailInStorage();
		if (!email) return;
		const obj = { email };
		const userResult = await getAdminDetails(obj);
		if (userResult?.data?.statusCode === 200) {
			const userData = userResult.data.data;
			sessionStorage.setItem("admin_user_name", userData.username || "");
			sessionStorage.setItem("admin_user_id", userData.id || "");
			sessionStorage.setItem("admin_mobile_number", userData.mobile_number || "")
		}
	}

	openResponseModal = (message, isSuccess,title='') => {
        analyticsClickEvent('admin_response_modal_opened', '');
        frontEndLogs('admin_response_modal_opened',false,200,'admin_dashboard');
		document.body.classList.add("modal-open");
		this.setState({
			showResponseModal: true,
			responseMessage: message,
			isSuccess,
            responseTitle: title
		});
	};

	closeResponseModal = () => {
		document.body.classList.remove("modal-open");
		this.setState({
			showResponseModal: false,
			responseMessage: "",
			isSuccess: false
		});
		window.location.reload();
	};

	handleSearchChange = async (e) => {
		const value = e.target.value;
		this.setState({searchValue: value,currentPage: 1});
		if (this.state.activeTab === "users") {
			const response = await getActiveLoginUsersList({search: value});
			if (response?.statusCode === 200) {
				this.setState({ users: response.data || []});
			}

		} else {
			const response = await getAdminList({
				search: value
			});
			if (response?.statusCode === 200) {
				this.setState({
					admins: response.data || []
				});
			}
		}
	};

	toggleDropdown = () => { this.setState(prevState => ({ showDropdown: !prevState.showDropdown })) }

	handleOutsideClick = (event) => {
		if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
			this.setState({ showDropdown: false })
		}
	}

	nextPage = () => {
		const currentUserData =this.state.activeTab === "users"? this.state.users: this.state.admins;
		const totalPages = Math.ceil(currentUserData.length / USERS_PER_PAGE);
		if (this.state.currentPage < totalPages) {
			this.setState(prevState => ({
				currentPage: prevState.currentPage < totalPages ? prevState.currentPage + 1 : prevState.currentPage
			}));
		}
	}

	prevPage = () => {
		this.setState(prevState => ({
			currentPage: prevState.currentPage > 1 ? prevState.currentPage - 1 : prevState.currentPage
		}));
	}

	getPaginationData = (filteredUsers) => {
		const lastIndex = this.state.currentPage * USERS_PER_PAGE;
		const firstIndex = lastIndex - USERS_PER_PAGE;
		const totalPages = Math.ceil(filteredUsers.length / USERS_PER_PAGE);
		const currentUsers = filteredUsers.slice(firstIndex, lastIndex);
		return { usersPerPage: USERS_PER_PAGE, lastIndex, firstIndex, totalPages, currentUsers };
	}

	getPageNumbers = (totalPages) => {
		const visiblePages = 3;
		let startPage = Math.max(1, this.state.currentPage - Math.floor(visiblePages / 2));
		let endPage = startPage + visiblePages - 1;
		if (endPage > totalPages) {
			endPage = totalPages;
			startPage = Math.max(1, endPage - visiblePages + 1);
		}
		const pageNumbers = [];
		for (let i = startPage; i <= endPage; i++) {
			pageNumbers.push(i);
		}
		return pageNumbers;
	}

	handleAdminLogout = async () => {
		if (this.state.loading) { return };
        analyticsClickEvent('admin_logout_clicked', '');
        frontEndLogs('admin_logout_clicked',false,200,'admin_dashboard');
		this.setState({ loading: true });
		try {
			await manualLogout();
            analyticsClickEvent('admin_logout_successful', '');
            frontEndLogs('admin_logout_successful',false,200,'admin_dashboard');
			localStorage.clear();
			sessionStorage.clear();

			this.props.navigate("/login");
		} catch (error) {
            frontEndLogs('admin_logout_failed',true,error?.response?.status || 500,'admin_dashboard');
			console.error(error);
			this.setState({ loading: false });
		}
	}

	handleLoginAsUser = (user) => {
        analyticsClickEvent('admin_login_as_user_clicked', '');
        frontEndLogs('admin_login_as_user_clicked',false,200,'admin_dashboard');
		const baseUrl = window.location.origin;
		const url = `${baseUrl}/admin-user-view?actor=${user.id}`;
		window.open(url, "_blank");
	}

	openDeleteModal = (admin) => {
        analyticsClickEvent('admin_delete_popup_opened', '');
        frontEndLogs('admin_delete_popup_opened',false,200,'admin_dashboard');
		document.body.classList.add("modal-open");
		this.setState({ showDeleteModal: true, selectedAdmin: admin });
	};

	closeDeleteModal = () => {
		document.body.classList.remove("modal-open");
		this.setState({ showDeleteModal: false, selectedAdmin: null });
	};

	openCreateModal = () => {
		document.body.classList.add("modal-open");
		this.setState({ showCreateModal: true });
	};

	closeCreateModal = () => {
		document.body.classList.remove("modal-open");
		this.setState({ showCreateModal: false });
	};

	render() {
		const currentUserData =this.state.activeTab === "users"? this.state.users : this.state.admins;
		const { totalPages, currentUsers } = this.getPaginationData(currentUserData);
		const pageNumbers = this.getPageNumbers(totalPages);
		const firstLetterOfUserName = sessionStorage.getItem('admin_user_name')?.charAt(0).toUpperCase();
		const idColumnLabel = this.state.activeTab === "users" ? "User Id" : "Admin Id";
		return (
			<>
				{this.state.loading && (
					<div className="loader-overlay">
						<Loader loaderStatus={true} />
					</div>
				)}
				<section className="admin-dashboard min-vh-100">
					<div className="header-section sticky-top">
						<div className="admin-dashboard-content">
							<div className="row align-items-center admin-dashboard-header-row g-2">
								<div className="col-4 col-lg-4 header-profile">
									<img src="images/logo.svg" alt="Humm" className="humm-logo img-fluid" />
								</div>

								<div
									className="col-4 order-3 col-lg-4 profile-section d-flex justify-content-end"
									ref={this.dropdownRef}
								>
									<div className="profile-image flex-shrink-0">
										{firstLetterOfUserName}
									</div>
									<span className="profile-name d-none d-sm-inline text-truncate">
										{sessionStorage.getItem("admin_user_name")}
									</span>
									<button
										type="button"
										className="dropdown-section flex-shrink-0"
										onClick={this.toggleDropdown}
										aria-expanded={this.state.showDropdown}
										aria-label="Profile menu"
									>
										{this.state.showDropdown ? (
											<img src="images/up-arrow.svg" alt="" />
										) : (
											<img src="images/down-arrow.svg" alt="" />
										)}
									</button>
									{this.state.showDropdown && (
										<div className="profile-dropdown">
											<button
												type="button"
												className="logout-option"
												onClick={this.handleAdminLogout}
											>
												Log out
											</button>
										</div>
									)}
								</div>

								<div className="col-4 col-lg-4 header-tabs d-flex justify-content-center align-items-center">
									<button
										type="button"
										className={this.state.activeTab === "users" ? "active-tab" : ""}
										onClick={() => this.setState({ activeTab: "users", currentPage: 1 })}
									>
										Users
									</button>
									<button
										type="button"
										className={this.state.activeTab === "admins" ? "active-tab" : ""}
										onClick={() => this.setState({ activeTab: "admins", currentPage: 1 })}
									>
										Admins
									</button>
								</div>
							</div>
						</div>
					</div>

					<div className="admin-dashboard-content search-bar-section">
						<div className="row g-3 align-items-center justify-content-md-end">
							{this.state.activeTab === "admins" && (
								<div className="col-12 col-md-auto mb-3 mb-md-0">
									<button
										type="button"
										className="create-admin-btn w-100 w-md-auto"
										onClick={this.openCreateModal}
									>
										<img src="images/iocn-accordion-plus.svg" alt="" />
										<span>Create New Admin</span>
									</button>
								</div>
							)}
							<div className="col-12 col-md-5 col-lg-3 ms-md-auto search-bar-right">
								<form className="search-icon w-100" onSubmit={(e) => e.preventDefault()}>
									<div className="form-group m-0 w-100 admin-dashboard-search">
										<input
											className="form-control w-100"
											name="searchValue"
											value={this.state.searchValue}
											placeholder={`Search by ${this.state.activeTab === "users" ? "user" : "admin"} email or name`}
											onChange={this.handleSearchChange}
											type="search"
										/>
										<span className="search-icon" aria-hidden="true">
											<img src="images/search-Icon-white.svg" alt="" />
										</span>
									</div>
								</form>
							</div>
						</div>
					</div>

					<div className="admin-dashboard-content user-table-section">
						<div className="table-responsive user-table-responsive d-none d-md-block">
							<table className="user-table table mb-0">
								<thead>
									<tr>
										<th>{this.state.activeTab === "users" ? "User Id" : "Admin Id"}</th>
										<th>Name</th>
										<th>Email</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{currentUsers.length > 0 ? (
										currentUsers.map((user, index) => (
											<tr key={user.email}>
												<td>{((this.state.currentPage - 1) * USERS_PER_PAGE) + index + 1}</td>
												<td>{user.name}</td>
												<td>{user.email}</td>
												<td>
													{
														this.state.activeTab === "users" ? (
															<button
																type="button"
																className="login-user-btn"
																onClick={() => this.handleLoginAsUser(user)}
															>
																Login As User
															</button>
														) : (
															<button
																type="button"
																className="delete-admin-btn"
																onClick={() => this.openDeleteModal(user)}
															>
																Delete
															</button>
														)
													}
												</td>
											</tr>
										))
									) : (
										<tr>
											<td colSpan="4">
												{this.state.activeTab === "users" ? "No Users Found" : "No Admins Found"}
											</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>

						<div className="d-md-none admin-user-cards mt-3">
							{currentUsers.length > 0 ? (
								currentUsers.map((user, index) => (
									<div className="admin-user-card" key={user.email}>
										<div className="admin-user-card-row">
											<span className="admin-user-card-label">{idColumnLabel}</span>
											<span>{((this.state.currentPage - 1) * USERS_PER_PAGE) + index + 1}</span>
										</div>
										<div className="admin-user-card-row">
											<span className="admin-user-card-label">Name</span>
											<span>{user.name}</span>
										</div>
										<div className="admin-user-card-row">
											<span className="admin-user-card-label">Email</span>
											<span className="text-break">{user.email}</span>
										</div>
										<div className="admin-user-card-actions">
											{this.state.activeTab === "users" ? (
												<button
													type="button"
													className="login-user-btn w-100"
													onClick={() => this.handleLoginAsUser(user)}
												>
													Login As User
												</button>
											) : (
												<button
													type="button"
													className="delete-admin-btn w-100"
													onClick={() => this.openDeleteModal(user)}
												>
													Delete
												</button>
											)}
										</div>
									</div>
								))
							) : (
								<div className="admin-user-card admin-user-card-empty">
									{this.state.activeTab === "users" ? "No Users Found" : "No Admins Found"}
								</div>
							)}
						</div>
					</div>

					<div className="admin-dashboard-content pagination-section">
						<button type="button" className="pagination-btn" onClick={this.prevPage}>Prev</button>
						{pageNumbers.map((number) => (
							<button type="button" key={number}
								className={this.state.currentPage === number ? "pagination-btn pagination-btn-active-page" : "pagination-btn"}
								onClick={() => this.setState({ currentPage: number })}
							>
								{number}
							</button>
						))}
						<button type="button" className="pagination-btn" onClick={this.nextPage}>Next</button>
					</div>

					<CreateAdminModal
						showCreateAdminModal={this.state.showCreateModal}
						closeCreateAdminModal={this.closeCreateModal}
						openResponseModal={this.openResponseModal}
						setLoading={(loading) => this.setState({ loading })}
					/>

					<SuccessModal
						showModal={this.state.showResponseModal}
						message={this.state.responseMessage}
						isSuccess={this.state.isSuccess}
						onClose={this.closeResponseModal}
                        title={this.state.responseTitle}
					/>

					<DeleteAdminModal
						showDeleteAdminModal={this.state.showDeleteModal}
						closeDeleteAdminModal={this.closeDeleteModal}
						selectedAdmin={this.state.selectedAdmin}
						openResponseModal={this.openResponseModal}
						setLoading={(loading) => this.setState({ loading })}
					/>
				</section>
			</>
		)
	}
}
export default withRouter(AdminDashboard)

AdminDashboard.propTypes = {
	navigate: PropTypes.func.isRequired,
};